import module from './module.js'
/* Components */
import './components/editor/component.js'
import './components/generador/component.js'

export default module.name



// WEBPACK FOOTER //
// ./src/fan/plantillas/index.js